import { Component, effect, inject, input } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpConditionsService } from '@features/lp/lp-conditions/lp-conditions.service';
import { LpConditionalVisibilityCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-conditional-visibility-canvas-component',
  imports: [],
  templateUrl: './lp-conditional-visibility-canvas-component.component.html',
  styleUrl: './lp-conditional-visibility-canvas-component.component.css',
})
export class LpConditionalVisibilityCanvasComponentComponent {
  readonly #lpConditionsService = inject(LpConditionsService);

  comp = input.required<LpConditionalVisibilityCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  constructor() {
    effect(async () => {
      this.#lpConditionsService.subscribe();

      const satisfied = await this.#lpConditionsService.evaluate(this.comp().visibleIf);
      this.context().setVisibility(satisfied);
    });
  }
}
